'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _constants = require('./constants');

var _propTypes = require('prop-types');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _provider = require('./provider');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Flag = function (_React$Component) {
  _inherits(Flag, _React$Component);

  function Flag() {
    _classCallCheck(this, Flag);

    return _possibleConstructorReturn(this, (Flag.__proto__ || Object.getPrototypeOf(Flag)).apply(this, arguments));
  }

  _createClass(Flag, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          flagName = _props.flagName,
          flag = _props.flag,
          trackEncounterFlag = _props.trackEncounterFlag;

      trackEncounterFlag(flagName, flag);
    }
  }, {
    key: 'render',
    value: function render() {
      var value = this.props.value;

      return value();
    }
  }]);

  return Flag;
}(_react2.default.Component);

Flag.propTypes = {
  flagName: _propTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  flag: _propTypes.object.isRequired,
  value: _propTypes.func.isRequired,
  trackEncounterFlag: _propTypes.func
};
Flag.defaultProps = {
  trackEncounterFlag: function trackEncounterFlag() {
    /* NOOP */
  }
};


var FeatureFlag = function FeatureFlag(_ref) {
  var flagName = _ref.flagName,
      on = _ref.on,
      off = _ref.off;
  return _react2.default.createElement(
    _provider.FeatureFlagsContext.Consumer,
    null,
    function (_ref2) {
      var getFeatureFlag = _ref2.getFeatureFlag,
          trackEncounterFlag = _ref2.trackEncounterFlag;

      var flag = getFeatureFlag(flagName);
      return _react2.default.createElement(Flag, {
        value: flag.value ? on : off,
        flag: flag,
        flagName: flagName,
        trackEncounterFlag: trackEncounterFlag
      });
    }
  );
};

FeatureFlag.propTypes = {
  flagName: _propTypes.string.isRequired,
  on: _propTypes.func.isRequired,
  off: _propTypes.func
};

FeatureFlag.defaultProps = {
  off: function off() {
    return null;
  },
  flagSource: _constants.flagSources.DEFAULT
};

exports.default = FeatureFlag;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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